import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";
import ServiceLocator from "../../../../../domain/service-locator";
import { useNavigationModule } from "@agp/shared.user-app/application/context/navigation";
import { useCallback } from "react";
import { MonotoneContainer } from "../../components/monotone-container";

export const MonotoneTopPage = () => {
  const languageRepository = ServiceLocator.LanguageRepository;
  const navigation = useNavigationModule();

  const handleClickStartButton = useCallback(
    (lang: "en-US" | "ja-JP") => {
      const language = languageRepository.languages.find(
        (x) => x.localeId === lang
      );

      languageRepository.updateCurrentLanguageId(language!.id);
      navigation.push(
        "note",
        {},
        {
          pageOutType: "fade",
          pageInType: "fade",
        }
      );
    },
    [languageRepository, navigation]
  );

  return (
    <AnimatedPageTransition>
      <div
        className="bg-white flex items-center justify-center"
        style={{ height: window.innerHeight }}
      >
        <MonotoneContainer>
          <img
            className={
              "[@media(min-height:200px)]:w-[85%] [@media(min-height:500px)]:w-[90%] [@media(min-height:600px)]:w-full flex-shrink-0 mx-auto"
            }
            src="/chanel/chanel-top.png"
            alt="top"
          />

          {/* Audio Guide Section */}
          <div className="w-full h-full px-4 sm:px-6 md:px-8 flex-1 flex flex-col justify-center gap-4 sm:gap-6 md:gap-8 lg:gap-10 min-h-0">
            <h4 className="text-3xl font-serif text-gray-700 leading-tight">
              Audio Guide
            </h4>
            <div className="flex gap-2 sm:gap-3 md:gap-4 justify-center px-4">
              <button
                onClick={() => handleClickStartButton("ja-JP")}
                className="bg-[#E6E6E6] border-[1px] border-[#999999] w-[50%] py-2 sm:py-2.5 md:py-3 rounded-full text-gray-700 text-2xl font-noto-serif-jp transition-all duration-200 hover:bg-[#DADADA] active:scale-95 [@media(min-height:200px)]:text-[12px] [@media(min-height:400px)]:text-xl [@media(min-height:600px)]:text-2xl"
              >
                日本語
              </button>
              <button
                onClick={() => handleClickStartButton("en-US")}
                className="bg-[#E6E6E6] border-[1px] border-[#999999] w-[50%] py-2 sm:py-2.5 md:py-3 rounded-full text-gray-700 text-2xl font-noto-serif-jp transition-all duration-200 hover:bg-[#DADADA] active:scale-95 [@media(min-height:200px)]:text-[12px] [@media(min-height:400px)]:text-xl [@media(min-height:600px)]:text-2xl"
              >
                English
              </button>
            </div>
          </div>
        </MonotoneContainer>
      </div>
    </AnimatedPageTransition>
  );
};
